import { defineStore } from "pinia";
import { createBaseStoreRefactor } from "./baseStoreRefactor";

const tenantsBaseStore = createBaseStoreRefactor({
  endpoint: "/api/v1/tenants",
  name: "TenantsStoreRefactor",
  objectName: "Tenant",
  enableCache: true,
  infiniteLoading: false,
});

export const useTenantsStoreRefactor = defineStore("tenantsRefactor", {
  ...tenantsBaseStore,

  getters: {
    ...tenantsBaseStore.getters,

    /**
     * Get all tenants (maps to state.data for compatibility)
     */
    tenants: (state) => {
      return state.data || [];
    },

    /**
     * Options for selects: [{ title, value }]
     */
    tenantOptions: (state) => {
      const list = state.data || [];
      return list.map((t) => ({
        title: t.display_name || t.name || t.slug || `Tenant #${t.id}`,
        value: t.id,
      }));
    },

    /**
     * Get tenant by ID
     */
    getTenantById: (state) => (id) => {
      return state.data.find((tenant) => tenant.id == id);
    },

    /**
     * Get tenant by slug
     */
    getTenantBySlug: (state) => (slug) => {
      return state.data.find((tenant) => tenant.slug === slug);
    },

    /**
     * Get total users count across all tenants
     */
    getTotalUsersCount: (state) => {
      return state.data.reduce(
        (total, tenant) => total + (tenant.users_count || 0),
        0,
      );
    },

    /**
     * Get total accounts count across all tenants
     */
    getTotalAccountsCount: (state) => {
      return state.data.reduce(
        (total, tenant) => total + (tenant.accounts_count || 0),
        0,
      );
    },
  },

  actions: {
    ...tenantsBaseStore.actions,
    // No custom actions needed; use base actions:
    // - fetchAll() to list
    // - fetchById(id) to refresh one
    // - update({ id, ...fields }) for JSON updates
    // - customApiCall('PATCH', `/api/v1/tenants/${id}`, FormData) for file uploads
  },
});
